// Client-only sidebar collapsed-layout flag. Persists via shared/storage.
// See react-rewrite-plan.md sections 6.3 and 11.4.

import { create } from 'zustand';
import { STORAGE_KEYS, createStorage } from '@/shared/storage';

const storage = createStorage('local');

interface SidebarLayoutState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (collapsed: boolean) => void;
}

const initialCollapsed = storage.get<boolean>(STORAGE_KEYS.sidebarCollapsed, false);

export const useSidebarLayoutStore = create<SidebarLayoutState>((set, get) => ({
  collapsed: initialCollapsed,
  toggle: () => {
    const next = !get().collapsed;
    storage.set(STORAGE_KEYS.sidebarCollapsed, next);
    set({ collapsed: next });
  },
  setCollapsed: (collapsed: boolean) => {
    storage.set(STORAGE_KEYS.sidebarCollapsed, collapsed);
    set({ collapsed });
  },
}));
